import { render, staticRenderFns } from "./RouterInputItem.vue?vue&type=template&id=ff140880&scoped=true"
import script from "./RouterInputItem.vue?vue&type=script&lang=js"
export * from "./RouterInputItem.vue?vue&type=script&lang=js"
import style0 from "./RouterInputItem.vue?vue&type=style&index=0&id=ff140880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff140880",
  null
  
)

export default component.exports